import React, { useState, useRef } from 'react';
import { DEFAULT_TTL, setLoginToken } from './Utils';

function Login() {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const passwordRef = useRef();

    const doLogin = () => {
        var protocl = window.location.protocol;
        if (username === "" || password === "") {
            window.layer.msg("请输入用户名和密码");
            return;
        }
        window.$.ajax({
            type: 'POST',
            url: protocl + '//saas.yonyouaud.com/api/client-info/generateAccessToken',
            contentType: 'application/json;charset=utf8',
            data: JSON.stringify({ "clientId": username, "username": username, "clientSecret": password, "ttl": DEFAULT_TTL }),
            success: function (data) {
                var code = data.errorCode;
                if (code && code === "success") {
                    window.layer.msg("登录成功");
                    data.username = username;
                    setLoginToken(data);
                    setTimeout(function () {
                        window.location.reload();
                    }, 1000);
                } else {
                    window.layer.msg(data.errorMessage);
                }
            }
        })
    }

    return <>
        <div className="login-6-left" style={{
            position: 'relative',
            width: '60vw',
            height: '100vh',
            background: 'linear-gradient(135deg, #0f2027 0%, #2c5364 40%, #5f2c82 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            backgroundImage: 'url(./assets/img/background.png)', 
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '95% center',
            backgroundSize: 'cover',
            backgroundColor: 'rgb(0 12 45)',
        }}>
            <div style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(0,0,0,0.25)',
                zIndex: 1
            }}></div>
            <div style={{
                position: 'relative',
                zIndex: 2,
                color: '#fff',
                textAlign: 'left',
                maxWidth: 600,
                padding: '0 40px',
            }}>
                <div style={{
                    fontSize: '3.2rem',
                    fontWeight: 'bold',
                    marginBottom: '1.5rem',
                    letterSpacing: 1,
                    lineHeight: 1.3
                }}>科技强审 · 智能引领</div>
                <div style={{
                    fontSize: '1.6rem',
                    fontWeight: 500,
                    lineHeight: 1.6,
                    marginBottom: '1rem',
                    opacity: 0.95
                }}>审友GPT · 让每一位审计人员拥有AI助手</div>
                <div style={{
                    fontSize: '1.2rem',
                    opacity: 0.85,
                    lineHeight: 1.6,
                }}>智能法规检索、审计案例分析、语言模型助理，开启智慧审计新时代。</div>
            </div>
        </div>

        <div className="login-6-right">
            <div className="login-top">
                <div className="login-6-left-header" style={{
                    paddingLeft: 36,
                }}>
                    <div className="login-6-logo">
                    </div>
                </div>
            </div>
            <div className="login-6-right-container">
                <div className="login-6-login-form">
                    <form className="layui-form login-bottom">
                        <div className="center">
                            <div className="loginTitleParent">
                                <div id="loginTitle" style={{
                                    textShadow: '0 4px 16px rgba(47,54,104,0.18), 0 1px 2px rgba(0,0,0,0.12)',
                                    fontWeight: 1000,
                                    fontSize: '2.5em',
                                    color: '#1E90FF'
                                }}>审友云</div>
                            </div>
                            <div className="item-label" style={{
                                color: '#505050',
                            }}>
                                <span className="label" id="accountLabel">账号/邮箱</span>
                            </div>
                            <div className="item">
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M8.00016 6.66732C9.47292 6.66732 10.6668 5.47341 10.6668 4.00065C10.6668 2.52789 9.47292 1.33398 8.00016 1.33398C6.5274 1.33398 5.3335 2.52789 5.3335 4.00065C5.3335 5.47341 6.5274 6.66732 8.00016 6.66732Z"
                                            stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M14 14.666C14 11.3523 11.3137 8.66602 8 8.66602C4.6863 8.66602 2 11.3523 2 14.666"
                                            stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <input type="text" name="username" lay-verify="required" maxLength="24" autoComplete="off" id="username"
                                    className="layui-input" style={{ paddingLeft: 40 }} value={username} onChange={(e) => setUsername(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            if (passwordRef.current) {
                                                passwordRef.current.focus();
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div className="item-label" style={{
                                color: '#505050',
                            }}>
                                <span className="label" id="passwordLabel">密码</span>
                            </div>
                            <div className="item">
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M13.3333 7.33398H2.66667C2.29848 7.33398 2 7.63246 2 8.00065V14.0007C2 14.3688 2.29848 14.6673 2.66667 14.6673H13.3333C13.7015 14.6673 14 14.3688 14 14.0007V8.00065C14 7.63246 13.7015 7.33398 13.3333 7.33398Z"
                                            stroke="#999999" strokeLinejoin="round" />
                                        <path
                                            d="M4.6665 7.33398V4.66732C4.6665 2.82637 6.1589 1.33398 7.99984 1.33398C9.84077 1.33398 11.3332 2.82637 11.3332 4.66732V7.33398"
                                            stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M8 10V12" stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <input type="password" name="password" lay-verify="required" autoComplete="off" maxLength="20"
                                    id="password" ref={passwordRef} className="layui-input" style={{ paddingLeft: 40 }} value={password} onChange={(e) => setPassword(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            doLogin();
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="tip">
                            <div id="loginerror-tip" style={{
                                textAlign: 'center',
                                fontSize: 14,
                                color: 'red',
                                fontWeight: 'bold',
                                border: '1px solid red',
                                padding: '8px 5px',
                                display: 'none',
                            }}></div>
                        </div>
                        <div className="layui-form-item">
                            <button type="button" className="login-btn" lay-submit="" lay-filter="login" id="loginBtn"
                                title="login" onClick={doLogin}>登&nbsp;&nbsp;&nbsp;&nbsp;录</button>
                        </div>
                    </form>
                </div>
            </div>
            <div className="main-footer">
                <span id="loginFooter">Copyright © {new Date().getFullYear()} <a rel="noreferrer" href="https://www.yonyouaud.com" target="_blank">北京审友数治科技有限公司</a> 版权所有.</span>
            </div>
        </div>
    </>
}

export default Login;